// helper for getting user token
import Cookies from 'js-cookie';

export const getUserToken = () => Cookies.get('api_token');

export default getUserToken;
